export function chartWithToggle() {
    let titleFontSize = 10;
    let xFontSize = 10;
    let quaterData;
    let yearlyData;
    let $switcherParent = $(".chart-switcher");
    let $switcherInput = $switcherParent.find("input");
    let $overlay = $switcherParent.find(".toggler");
    let switchVal = $switcherParent.find(".switcher-val");
    let quaterDataPath = $(switchVal[0]).data("src");
    let yearlyDataDataPath = $(switchVal[1]).data("src");
    let counter = 0;
    let finalData;
    let dataKyes = ["IYR ETF", "S&P 500", "NCREIF Property Index Returns"];
    let chart;
    let generateData = function (array, keys, type) {
        finalData = [];

        array.map((item, index) => {
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];
                let itemData = {};

                itemData.id = key;
                if (type === "yearly") {
                    itemData.x = item["Quarter"].slice(0, item["Quarter"].length - 3);
                } else {
                    itemData.x = item["Quarter"];
                }
                if (item[key].includes("%")) {
                    itemData.y = item[key].slice(0, item[key].length - 1);
                } else {
                    itemData.y = item[key];
                }

                finalData.push(itemData);
            }
        });

        return finalData;
    };
    let setData = function (data, range) {
        if (data) {

            if (range === "yearly") {
                let result = d3.csvParse(data);
                delete result.columns;

                yearlyData = generateData(result, dataKyes, range);

            } else {
                let result = d3.csvParse(data);
                delete result.columns;

                quaterData = generateData(result, dataKyes);
            }
        }
    };
    let initChart = function () {

        chart = new d3plus.Plot()
            .data(quaterData)
            .groupBy("id")
            .discrete("x")
            .shape("Line")
            .select(".chart-inner")
            .groupPadding(0)
            .x(d => d.x)
            .y(d => Number(d.y))
            .shapeConfig({
                Line: {
                    stroke: d => {if (d.id === "S&P 500") return "#4EE5CC"; if (d.id === "IYR ETF") return "#007395"; if (d.id === "NCREIF Property Index Returns") return "#1D2328";}
                }
            })
            .legendPosition("bottom")
            .legendConfig(
                {
                    align: "left",
                    shape: "Circle",
                    shapeConfig: {
                        labelConfig: {
                            fontColor: "#1D2328",
                            fontMax: 12,
                        },
                        r: () => {
                            return 9;
                        },
                    },
                    padding: 5,
                }
            )
            .xConfig({
                gridConfig: {
                    stroke: "#1d23001a"
                },
                labelRotation: true,
                shapeConfig: {
                    fill: "#fff",
                    stroke: "#fff",
                    labelConfig: {
                        fontColor: function (d) {

                            if ($(window).width() < 568 && this.data().length > 30) {

                                counter++;

                                if (counter % 2 === 0 || counter % 3) {
                                    return "rgba(255,255,255,0)";
                                } 
                                else {
                                    return "#1D2328";
                                }
                            } else if (this.data().length > 100) {

                                counter++;
                                if (counter % 2 === 0) {
                                    return "rgba(255,255,255,0)";
                                } else {
                                    return "#1D2328";
                                }
                            } else {
                                return "#1D2328";
                            }
                        },
                        fontSize: () => {
                            return xFontSize;
                        },
                    },
                },
                barConfig: {
                    stroke: "#1d23001a",
                },
            })
            .yConfig({
                gridConfig: {
                    stroke: "#1d23001a",
                },
                shapeConfig: {
                    fill: "#fff",
                    stroke: "#fff",
                    labelConfig: {
                        fontColor: "#1D2328",
                        fontSize: () => {
                            return xFontSize;
                        },
                    },
                },
                barConfig: {
                    stroke: "#1d23001a",
                },
                title: "Growth (%)",
                titleConfig: {
                    fontColor: "#1D2328",
                    fontSize: titleFontSize,
                },
            })
            .attributionStyle({
                font: "400 10px/10px 'Grotesk', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                padding: "0 0 0",
            })
            .colorScaleMaxSize(400)
            .tooltip(false)
            .render();
    };

    if ($(window).width() > 767) {
        titleFontSize = 14;
        xFontSize = 12;
    }

    $(document).ready(function () {
        $.ajax({
            type: "GET",
            url: yearlyDataDataPath,
            dataType: "text",
            success: function (result) {setData(result, "yearly");}
        });

        $.ajax({
            type: "GET",
            url: quaterDataPath,
            dataType: "text",
            success: function (result) {setData(result); initChart();}
        });
    });

    $switcherInput.on("change", e => {
        if(e.target.checked){
            $switcherParent.addClass("changed");
            $overlay.css({
                "width": $(switchVal[1]).outerWidth() + "px",
                "left": "calc(100% - " + $(switchVal[1]).outerWidth() + "px)"
            });

            $(chart.select()._groups[0]).find(".d3plus-plot-x-axis .grid > line").remove();
            counter = 0;
            chart
                .data(yearlyData)
                .render();
        } else {
            $switcherParent.removeClass("changed");
            $overlay.css({
                "width": $(switchVal[0]).outerWidth(),
                "left": 0
            });

            $(chart.select()._groups[0]).find(".d3plus-plot-x-axis .grid > line").remove();
            counter = 0;

            chart
                .data(quaterData)
                .render();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/chartWithToggle.js